import { OptoColors } from '@/config/settings';

/**
 * Chart.js renders on <canvas> and cannot resolve CSS custom properties.
 * Values come from OptoColors design tokens.
 */
export const HEALTH_DEVELOPMENT_CHART_COLORS = {
    green: OptoColors.OceanGreen,
    orange: OptoColors.Orange,
    red: OptoColors.Red,
    riverside: OptoColors.Riverside,
    yellow: OptoColors.Yellow,
} as const;

export type HealthDevelopmentChartColor =
    (typeof HEALTH_DEVELOPMENT_CHART_COLORS)[keyof typeof HEALTH_DEVELOPMENT_CHART_COLORS];
